import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import OrderViewDeliver from "./OrderViewDeliver";
import ReturnReason from "./ReturnReason";
import OOSModal from "./OOSModal";
import CustomModal from "./CustomModal";
import ItemsOrderQty from "./ItemsOrderQty";
import DeliveryOrderTotal from "./DeliveryOrderTotal";
import AmtToBeCollect from "./AmtToBeCollect";
import { notify } from "react-notify-toast";
import {
  actionOrderDetails,
  actionProcessingJobs,
  actionDeliverySuccessDetails,
} from "../../../actions/index";
import { bindActionCreators } from "redux";
import Loader from "react-loader";
import { NavLink } from "react-router-dom";
import notification from "../../../images/notifications_white.svg";
import api from "../../../utility/api/api.js";
import createHistory from "history/createBrowserHistory";
import { Row, Col } from "reactstrap";
import DelayReasonModal from "../DeliverOrder/DelayReasonModal.js";

class DeliveryOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modifiedItems: [],
      returnOrderItemstate: "",
      lowBalModalVisible: false,
      showDelayReasonModal: false,
      paymentValidationError: "",
      selectedDelayReason: null,
    };
    const history = createHistory();
    const unlisten = history.listen((location, action) => {});
  }
  componentDidUpdate() {
    localStorage.setItem("orderData", JSON.stringify(this.props.orderData));
  }
  async deliverOrder(selectedReason) {
    // e.preventDefault();

    let updateOrderArr = [];
    console.log("this.props.orderData", this.props.orderData.order_items);
    this.props.orderData &&
      this.props.orderData.order_items.delivered.map((order) => {
        const eachDiscountAmount = (order.is_qty_decimal == "1"
          ? parseFloat(order.discount_amount)
          : parseFloat(order.discount_amount) / parseFloat(order.qty_ordered)
        ).toFixed(3);

        const decresedAmnt = (
          (parseFloat(order.price) - eachDiscountAmount) *
          (order.qty_refused + parseInt(order.qty_refunded))
        ).toFixed(3);
        order.qty_refused && order.qty_refused > 0
          ? updateOrderArr.push({
              sku: order.sku,
              item_id: order.item_id,
              qty: order.qty_refused,
              amount: decresedAmnt,
            })
          : null;
      });
    console.log("updateOrderArr", updateOrderArr);


    // return;

    const refoundAmount = this.props.orderData.refund_amount
      ? parseFloat(this.props.orderData.refund_amount).toFixed(3)
      : 0 + this.props.orderData.total_refunded
      ? parseFloat(this.props.orderData.total_refunded).toFixed(3)
      : 0;

    const toPay = (
      parseFloat(this.props.orderData.amount_to_be_collected) -
      parseFloat(refoundAmount)
    ).toFixed(3);
    console.log("updateOrderArrLength", updateOrderArr.length);

    // if (updateOrderArr.length > 0) {
      await api.callPartialReturnOrderItem(
        null,
        this.props.orderData.job_order_id,
        updateOrderArr
      );
    // }
    console.log("aaaaaGuna", toPay);

    if (toPay <= 0) {
      const paymentBody = {
        jobOrderId: this.props.orderData.job_order_id,
        amount_paid: toPay,
        paymentType: "cash",
        ...(this.state.delay_time && selectedReason)
          ? {
            delayTripOrder: {
              "jobOrderId": this.props.orderData.job_order_id,
              "reason": selectedReason.reason,
              "time": this.state.delay_time
            }
          }
          : {}
      };
      await api.riderCashPayment(this, paymentBody);
    } else {
      this.setState({
        returnOrderItemstate: {
          ...this.state.returnOrderItemstate,
          ...{ status: "success" },
        },
      });
    }

    // this.setState({
    //   returnOrderItemstate: {
    //     ...this.state.returnOrderItemstate,
    //     ...{ status: "success" },
    //   },
    // });

    console.log("returnOrderItemstate", this.state.returnOrderItemstate);
  }
  handlePaymentButton = () => {
    if (
      this.props.orderData &&
      this.props.orderData.amount_to_be_collected > 0
    ) {
      this.deliverOrder();
    } else {
      this.setState({ lowBalModalVisible: true });
    }
  };
  toggleLowBalanceModal = (data) => {
    if (data == "ok") {
      this.deliverOrder();
    }
    this.setState({
      lowBalModalVisible: !this.state.lowBalModalVisible,
    });
  };

  handleDelayReasonSubmit = async (e, selectedReasonObj) => {   
    // Retry payment with the selected delay reason
    await this.deliverOrder(selectedReasonObj);
    // Close the modal
    this.setState({
      showDelayReasonModal: false,
      selectedDelayReason: selectedReasonObj,
    });
  };

  handleDelayReasonModalClose = () => {
    this.setState({
      showDelayReasonModal: false,
      paymentValidationError: "",
      selectedDelayReason: null
    });
  };

  render() {
    // if (orderData) {
    //   const refoundAmount = this.props.orderData.refund_amount
    //     ? parseFloat(this.props.orderData.refund_amount).toFixed(3)
    //     : 0 + this.props.orderData.total_refunded
    //     ? parseFloat(this.props.orderData.total_refunded).toFixed(3)
    //     : 0;

    //   const toPay = (
    //     parseFloat(this.props.orderData.amount_to_be_collected) -
    //     parseFloat(refoundAmount)
    //   ).toFixed(3);
    // }
    if (
      this.state.returnOrderItemstate &&
      this.state.returnOrderItemstate.status == "success"
    ) {
      const orderData = Object.assign({}, this.props.orderData);

      const refoundAmount = orderData.refund_amount
        ? parseFloat(orderData.refund_amount).toFixed(3)
        : 0 + orderData.total_refunded
        ? parseFloat(orderData.total_refunded).toFixed(3)
        : 0;

      const toPay = (
        parseFloat(orderData.amount_to_be_collected) - parseFloat(refoundAmount)
      ).toFixed(3);

      const deliver = toPay <= 0;
      if (deliver) {
        this.props.history.push("/deliverysuccess");
      } else {
        this.props.history.push("/paymentcardcash");
      }
    } else if (
      this.state.returnOrderItemstate &&
      this.state.returnOrderItemstate.status == "/020"
    ) {
      notify.show(this.state.returnOrderItemstate.message, "error");
    }
    if (!this.props.orderData) {
      return (
        <div className="">
          <div className="container mw-100">
            <div className="rider-header position-fixed deliver-custom-header">
              <div className="header-left-side">
                <div>
                  <NavLink to="/intransit">
                    <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
                  </NavLink>
                  <span className="text-white hub-header-title"></span>
                  <img
                    className="float-right pt-1"
                    // src={notification}
                    // alt="notification"
                  />
                </div>
              </div>
            </div>
            <Loader
              loaded={false}
              lines={13}
              length={20}
              width={10}
              radius={30}
              corners={1}
              rotate={0}
              direction={1}
              color="#e51837"
              speed={1}
              trail={60}
              shadow={false}
              hwaccel={false}
              className="spinner"
              zIndex={2e9}
              top="50%"
              left="50%"
              scale={1.0}
              loadedClassName="loadedContent"
            />
          </div>
        </div>
      );
    }
    const orderData = Object.assign({}, this.props.orderData);
    const deliver = orderData.amount_to_be_collected ? false : true;
    let totalReturnCount = orderData.order_items.delivered.reduce(
      (total, current) => total + parseFloat(current.qty_refused),
      0
    );
    const isQuantity =
      orderData.total_qty_ordered == totalReturnCount ? true : false;

    if (orderData) {
      return (
        <Fragment>
          <div className="container mw-100">
            <div className="rider-header position-fixed deliver-custom-header">
              <div className="header-left-side">
                <div className="deliverOrderHeader">
                  <NavLink to="/intransit">
                    <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
                  </NavLink>
                  <span className="text-white hub-header-title inTransitHeaderTitle">
                    {orderData.increment_id}
                  </span>
                  <img
                    className="float-right pt-1"
                    // src={notification}
                    // alt="notification"
                  />
                </div>
              </div>
            </div>
            <div className="maincontent deliver-order-comp">
              {/* <OrderViewDeliver orderdetail={orderData} /> */}
              <Row className="deliverItemOrderData">
                {/* <div className="deliverItemOrderDataItem">
                  <span>{orderData.job_order_id}</span>
                </div> */}
                {/* <div className="deliverItemOrderDataItem">
                  Order ID <br /> {orderData.order_id}
                </div> */}
                <div className="deliverItemOrderDataItem">
                  Status <br /> {orderData.order_status}
                </div>
                <div x className="deliverItemOrderDataItem">
                  Amount <br /> {parseFloat(orderData.order_amount).toFixed(3)}
                </div>
                <div className="deliverItemOrderDataItem">
                  Payment Mode <br /> {orderData.method}
                </div>
              </Row>
              <div className="delivery_order_table">
                {/* <div className="delivery_order_table_head mt-3">
                  <span className="product_name">PRODUCT</span>
                  <span className="product_unit_price">UNIT PRICE</span>
                  <span className="product_qty">QTY</span>
                  <span className="product_total_price">T.PRICE</span>
                </div> */}
                {orderData.order_items.delivered.map((obj, k) => (
                  <ItemsOrderQty
                    key={k}
                    itemdetail={obj}
                    onChangeQuantity={(item) => console.log(item)}
                  />
                ))}
              </div>
              <DeliveryOrderTotal orderTotal={orderData} />
              {/* <AmtToBeCollect TotalAmt={orderData} /> */}
            </div>
          </div>
          <div className="return_deliver_btn_container mt-2">
            <div className="return_btn">
              {/* <ReturnReason orderData={this.props.orderData} label="Return" /> */}
              <OOSModal orderData={this.props.orderData} />
            </div>
            <CustomModal component={this} />
            <div className="text-danger error_message">{this.state.error}</div>
            <div className={isQuantity ? "disableBtn" : "deliver_btn"}>
              {deliver ? (
                <button
                  className="deliver_payment_btn"
                  onClick={(e) => this.handlePaymentButton(e)}
                  disabled={isQuantity}
                >
                  PAYMENT
                </button>
              ) : (
                <button
                  className="deliver_payment_btn"
                  onClick={(e) => this.handlePaymentButton(e)}
                  disabled={isQuantity}
                >
                  PAYMENT
                </button>
              )}
            </div>
          </div>
          <DelayReasonModal
            delay_time={this.state.delay_time}
            isOpen={this.state.showDelayReasonModal}
            onClose={this.handleDelayReasonModalClose}
            errorMsg={this.state.paymentValidationError}
            onReasonSubmit={this.handleDelayReasonSubmit}
          />
        </Fragment>
      );
    } else {
      return null;
    }
  }
}
function mapStateToProps(state) {
  console.log("DeliveryOrder", state);
  return {
    orderData: state.orderDetails,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionOrderDetails: actionOrderDetails,
      actionDeliverySuccessDetails: actionDeliverySuccessDetails,
      actionProcessingJobs: actionProcessingJobs,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryOrder);



// WEBPACK FOOTER //
// ./src/components/Intransit/DeliverOrder/DeliveryOrder.js